module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "component-box"
  }, [(!_vm.showVerifyForm && !_vm.showVerifySuccess) ? _c('verify') : _vm._e(), _vm._v(" "), (_vm.showVerifyForm) ? _c('verify-email-form') : _vm._e(), _vm._v(" "), (_vm.showVerifySuccess) ? _c('verify-email-success') : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-558206dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/verify/Index.vue
// module id = 1325
// module chunks = 1